import { PageTransition, StaggerItem } from '../app/page-transition.js';

export function NotFoundPage() {
  return (
    <PageTransition>
      <StaggerItem>
        <h1 className="text-h1 font-semibold text-primary mb-2">Page not found</h1>
      </StaggerItem>
      <StaggerItem>
        <p className="text-body text-secondary">The page you are looking for does not exist.</p>
      </StaggerItem>
    </PageTransition>
  );
}
